import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'page-addons-trigger-version-pro',
  templateUrl: 'addons-trigger-version-pro.html',
})
export class AddonsTriggerVersionProPage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService) {

  }

  close() {
    this.navCtrl.pop();
  }

  openVersionPro() {
    //link a wordpress
    //this.globals.openLandingPricing();
    if (this.globals.restaurant.license == 'free') {
      this.globals.openPayProMonthBlank();
    } else if (this.globals.restaurant.license == 'basic') {
      this.globals.openPayProMonthBlank();
    } else if (this.globals.restaurant.license == 'pro') {
      this.globals.openPayBusinessMonthBlank();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/addons/addons-trigger-version-pro/addons-trigger-version-pro.ts